import * as React from 'react';

export interface RowActionButtonProps {
  icon?: string;
  text?: string;
  item: any;
  onClick: (e: any) => void;
  active?: boolean;
  altText?: string;
}
export class RowActionButton extends React.Component<RowActionButtonProps, {}> {
  handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    this.props.onClick(this.props.item);
  };

  render() {
    return (
      <button
        className={'btn btn-secondary btn-sm' + (this.props.active ? ' active' : '')}
        onClick={this.handleClick}
        title={this.props.altText}
      >
        {this.props.icon && <i className={'fa fa-' + this.props.icon} />}
        {this.props.text && <span> {this.props.text}</span>}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/RowActionButton.tsx